module.exports = __webpack_public_path__ + "static/media/add.cd9144b1.svg";